export enum PinnedItemType {
	/// <summary>
	///    A pinned news item.
	/// </summary>
	News,
}
